/**
 * Kortingsredenen voor de UI.
 *
 * Spiegel van `api/_lib/discount-reasons.ts` — houd beide lijsten gelijk. De
 * API valideert; deze lijst bepaalt alleen wat de medewerker ziet.
 */

export const DISCOUNT_REASONS = [
  'campagne',
  'klacht',
  'coulance',
  'commercieel',
  'correctie',
  'anders',
] as const;

export type DiscountReason = (typeof DISCOUNT_REASONS)[number];

export interface DiscountReasonOption {
  value: DiscountReason;
  label: string;
  hint: string;
  /** Vrije toelichting verplicht — spiegelt NOTE_REQUIRED in de API. */
  noteRequired: boolean;
}

export const DISCOUNT_REASON_OPTIONS: DiscountReasonOption[] = [
  {
    value: 'campagne',
    label: 'Campagne of mailing',
    hint: 'Klant reageert op een kortingsmail. Check eerst de marketing-chip.',
    noteRequired: false,
  },
  {
    value: 'klacht',
    label: 'Compensatie na klacht',
    hint: 'Korting als oplossing voor een klacht.',
    noteRequired: false,
  },
  {
    value: 'coulance',
    label: 'Coulance',
    hint: 'Goodwill zonder klacht, bijvoorbeeld na een late levering.',
    noteRequired: false,
  },
  {
    value: 'commercieel',
    label: 'Prijsafspraak',
    hint: 'Wederverkoper, volume of een vooraf afgesproken tarief.',
    noteRequired: false,
  },
  {
    value: 'correctie',
    label: 'Correctie',
    hint: 'Administratieve rechtzetting van een eerdere fout.',
    noteRequired: false,
  },
  {
    value: 'anders',
    label: 'Anders',
    hint: 'Licht kort toe waarom.',
    noteRequired: true,
  },
];

export const REASON_NOTE_MAX = 280;

export function reasonOption(value: DiscountReason | null): DiscountReasonOption | null {
  if (!value) return null;
  return DISCOUNT_REASON_OPTIONS.find((o) => o.value === value) ?? null;
}
